<template>
      <div class="row wrapper border-bottom white-bg page-heading mb-2">
        <div class="d-flex align-self-center justify-content-between col-md-10">
            <!-- <h2 class="mt-0">Real-time monitoring of data queries and quality metrics</h2> -->
            <h2 class="mt-0" >{{ $t('navigations.risk based quality management') }} <small> -Last updated: {{ lastUpdated }}</small></h2>
        </div>
        <div class="d-flex align-items-center col-md-2">
              <label for="siteChange" class="w-100">Select Site</label>
                <select id="siteChange" class="form-select py-1" v-model="currentsiteid" @change="siteidchanges()">
                  <option selected value="">{{$t('navigations.all')}}</option>
              <option
                v-for="site in uniqueSiteCodes"
                :key="site.siteID"
                :value="site.siteID"
              >
                {{ site.siteCode }}
              </option>
                </select>
        </div>
      </div>
      <!-- Summary Cards -->
      <div class="row mb-0 px-2">
        <div class="col-md-3 px-1" v-for="metric in summaryMetrics" :key="metric.title">
          <SummaryCard :metric="metric" />
        </div>
      </div>
  
      <!-- Detailed Metrics Section -->
      <div class="row">
        <div class="col-md-8">
          <div class="card">
            <div class="card-header bg-primary text-white">
              <h6 class="mb-0">Query Trends Over Time</h6>
            </div>
            <div class="card-body">
              <apexchart 
                type="line" 
                height="350" 
                :options="charts.queryTrends.options" 
                :series="charts.queryTrends.series">
              </apexchart>
            </div>
          </div>
        </div>
  
        <div class="col-md-4">
          <div class="card card-minheight">
            <div class="card-header bg-info text-white">
              <h6 class="mb-0">Query Distribution by Priority</h6>
            </div>
            <div class="card-body" style="width:100%; min-height:400px;">
              <apexchart
                ref="priorityChart"
                type="donut" 
                :options="charts.priority.options" 
                :series="charts.priority.series">
              </apexchart>
            </div>
          </div>
        </div>
      </div>
  
      <!-- Sites with Most Queries -->
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header bg-warning text-dark">
              <h6 class="mb-0">Sites Requiring Attention (Most Open Queries)</h6>
            </div>
            <div class="card-body">
              <ProblematicSitesTable :sites="problematicSites" />
            </div>
          </div>
        </div>
      </div>
  
      <!-- Query Aging and Resolution Rate -->
      <div class="row">
        <div class="col-md-6">
          <div class="card">
            <div class="card-header bg-secondary text-white">
              <h6 class="mb-0">Query Aging</h6>
            </div>
            <div class="card-body">
              <apexchart 
                type="bar" 
                height="350" 
                :options="charts.aging.options" 
                :series="charts.aging.series">
              </apexchart>
            </div>
          </div>
        </div>
  
        <div class="col-md-6">
          <div class="card">
            <div class="card-header bg-success text-white">
              <h6 class="mb-0">Weekly Resolution Rate</h6>
            </div>
            <div class="card-body">
              <apexchart 
                type="line" 
                height="350" 
                :options="charts.resolution.options" 
                :series="charts.resolution.series">
              </apexchart>
            </div>
          </div>
        </div>
      </div>
  </template>
  
  <script>

    import { defineComponent } from 'vue';
    import VueApexCharts from "vue3-apexcharts";
    import RiskBasedMonitoring from './RiskBasedMonitoring.js'
    import SummaryCard from './SummaryCard.vue'
    import ProblematicSitesTable from './ProblematicSitesTable.vue'

    export default defineComponent({
    name: 'RiskBasedMonitoring',
    components: {
        SummaryCard,
        ProblematicSitesTable,
        apexchart: VueApexCharts
    },
    mixins: [RiskBasedMonitoring],

    });
 </script>
  
  <style scoped>
  .ctms-dashboard {
    padding: 20px;
    background-color: #f8f9fa;
  }
  
  .header {
    background-color: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  }
  
  .last-updated {
    font-size: 0.8rem;
    color: #6c757d;
    text-align: right;
  }
  
  .card {
    margin-bottom: 20px;
    border: none;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    border-radius: 10px;
  }
  
  .card-header {
    border-radius: 10px 10px 0px 0px !important;
    padding:4px 10px !important;
  }
  .card-minheight {
    min-height: 425px;
}
  </style>